export { default as Image } from './Image';
export { default as Text } from './Text';
export { default as Shape } from './Shape';
export { default as PersonalCode } from './PersonalCode';
